import { ChangeDetectionStrategy, Component, Input, OnInit } from '@angular/core';

import { AccaBoostConfig, Sitecore } from '@frontend/sports/common/client-config-data-access';
import { StringInterpolationPipe } from '@frontend/sports/common/core/utils/string-interpolation';

import { AccaBoostError } from '../../../model';
import { AccaBoostNotificationService } from '../../../services/acca-boost-notification.service';
import { BaseAccaBoostErroromponent, ViewModel } from '../../acca-boost-error/base-acca-boost-error.component';

@Component({
    selector: 'bs-acca-boost-error',
    templateUrl: `./acca-boost-error.component.html`,
    styleUrls: ['./acca-boost-error.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false,
})
export class AccaBoostErrorComponent extends BaseAccaBoostErroromponent implements OnInit {
    @Input() isTrendingAccas = false;
    vm: ViewModel;
    constructor(
        protected override sitecore: Sitecore,
        protected override accaBoostNotificationService: AccaBoostNotificationService,
        protected override stringInterpolationPipe: StringInterpolationPipe,
        protected override accaBoostConfig: AccaBoostConfig,
    ) {
        super(sitecore, accaBoostNotificationService, stringInterpolationPipe, accaBoostConfig);
    }

    ngOnInit(): void {
        this.vm = {
            title: this.sitecore.accaBoost.ErrorNotificationTitle,
            errorMessage: this.errorsMap[this.error],
        };

        if (this.error === AccaBoostError.InvalidGameType) {
            this.vm.errorMessage = this.invalidGameTypeErrorsMap[this.token.filter.gameType!];
        } else if (this.error === AccaBoostError.MinOdds) {
            const minOddsMessage = this.isTrendingAccas ? this.sitecore.accaBoost.TrendingAccaMinOddsError : this.errorsMap[this.error];
            const minOddsPerLeg = this.accaBoostNotificationService.getUserBettingOddsFormatMinOdds(this.token.filter.minOddsPerLeg);
            this.vm.errorMessage = this.stringInterpolationPipe.transform(minOddsMessage, {
                minodds: minOddsPerLeg,
            });
        }
    }
}
